import React from "react";
import {connect} from 'react-redux'

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import IconButton from "@material-ui/core/IconButton";

import WarningTooltip from "../../../../components/WarningTooltip";
import PrimaryButton from "../../../../components/Buttons/PrimaryButton";
import {
  CustomerSelectionActions,
  CustomerSelectionContent
} from "../../../ProductComparison/components/CustomerSelectionModal/ProductSourceSelectionModal";
import {ModelPortfolioResource} from "../../../../utils/api";
import {displayErrorSnackBar, displaySuccessSnackBar} from "../../../../components/SnackbarProvider/actions";
import {SERVER_ERROR} from "../../../../utils/constants";
import {executeIfPathExist, getInvestmentDynamicPath} from "../../../InvestmentPlatform/utils";
import {getInvestmentPlatformSelector} from "../../../../utils/redaxSelectors";
import MPExternalDepotModal
  from "../../../CustomerDashboardV2/components_v2/ExternalDepots/components/MPExternalDepotModal";


const Icon = () => <FontAwesomeIcon icon={['fa', 'analytics']} fixedWidth/>;

const AddToCustomerButton = (props) => {
  const {onlyIcon, customClasses, item} = props;

  const [isOpen, setOpen] = React.useState(false);

  const title = 'Zu Kunden hinzufügen';
  const openCustomerSelection = () => setOpen(true);

  return (
    <>
      {onlyIcon ? (
        <WarningTooltip
          title={title}
          classes={customClasses}
          icon={
            <IconButton color={"primary"} onClick={openCustomerSelection}>
              <Icon />
            </IconButton>
          }
        />
      ) : (
        <PrimaryButton
          text={title}
          variant={"text"}
          onButtonClick={openCustomerSelection}
          icon={<Icon />}
          customClasses={customClasses}
        />
      )}
      <AddModal
        item={item}
        isOpen={isOpen}
        handleClose={() => setOpen(false)}
      />
    </>
  )
};

const mapStateToProps = (state) => ({
  investmentPlatform: getInvestmentPlatformSelector(state)
});

export default AddToCustomerButton;

const AddModal = connect(mapStateToProps)((props) => {
  const {dispatch, investmentPlatform, item, isOpen, handleClose} = props;

  const [selectedCustomers, setSelectedCustomers] = React.useState([]);
  const [isCopyInProgress, setCopyInProgress] = React.useState(false);
  const [formData, setFormData] = React.useState(undefined);

  const copyToCustomer = () => {
    const customer = selectedCustomers[0];
    const customerId = customer.customer_id;

    setCopyInProgress(true);
    ModelPortfolioResource.cloneToCustomer(item.id, customerId, formData)
      .then(() => executeIfPathExist(investmentPlatform.routes, 'DASHBOARD', path => {
        dispatch(displaySuccessSnackBar(
          <span>
            Das Musterdepot wurde erfolgreich als Fremddepot zur Vermögensübersicht des Kunden&nbsp;
            <a href={`/${getInvestmentDynamicPath()}${path.replace(':customer_id', customerId)}`} target='_blank'>
              <b>{customer.customer_full_name}</b>
            </a>
            &nbsp;hinzugefügt.
          </span>, null
        ))
      }, ':customer_id'))
      .catch(() => {
        dispatch(displayErrorSnackBar(SERVER_ERROR))
      }).finally(() => {
        setCopyInProgress(false);
        handleClose();
        resetForm()
      });
  };

  const resetForm = () => setFormData(undefined);

  const onExited = () => {
    resetForm();
    setSelectedCustomers([]);
  }

  return (
    <MPExternalDepotModal
      title={<>
        Fremddepot zu folgenden Kunden importieren <WarningTooltip title={'Fügen Sie eine Kopie eines zuvor erstellten Musterdepots als Fremddepot zur Vermögensübersicht hinzu.'} />
      </>}
      handleClose={handleClose}
      open={isOpen}
      modalLoading={isCopyInProgress}
      portfolio={item}
      formData={formData}
      setFormData={setFormData}
      handleSave={copyToCustomer}
      handleBack={resetForm}
      onExited={onExited}
      actions={
        <CustomerSelectionActions
          singleSelection
          selectedCustomers={selectedCustomers}
          confirmText={'Als Fremddepot hinzufügen'}
          handleConfirm={() => setFormData({...item})}
        />
      }
    >
      <CustomerSelectionContent
        singleSelection
        selectedCustomers={selectedCustomers}
        setSelectedCustomers={setSelectedCustomers}
      />
    </MPExternalDepotModal>
  )
})